import { Injectable } from '@angular/core';
import { ComponentInitCallbackFactory, GoldenLayoutService } from '@embedded-enterprises/ng6-golden-layout';
import * as GoldenLayout from 'golden-layout';
import { Subject, AsyncSubject } from 'rxjs';

/**
 * Extend the base GoldenLayoutService to expose the GoldenLayout object
 * To use this, provide it in the app.module like:
 * {
 *    provide: GoldenLayoutService,
 *    useClass: GoldenLayoutExtService
 * }
 */

@Injectable()
export class GoldenLayoutExtService extends GoldenLayoutService {
  get goldenLayout(): GoldenLayout {
    return this['_layout'] as GoldenLayout;
  }

  private initializedSubject = new AsyncSubject<void>();
  initialized$ = this.initializedSubject.asObservable();

  private componentCreatedSubject = new Subject<GoldenLayout.ContentItem>();
  readonly componentCreated$ = this.componentCreatedSubject.asObservable();

  private componentDestroyedSubject = new Subject<GoldenLayout.ContentItem>();
  readonly componentDestroyed$ = this.componentDestroyedSubject.asObservable();

  private activeContentItemChangedSubject = new Subject<GoldenLayout.ContentItem>();
  readonly activeContentItemChanged$ = this.activeContentItemChangedSubject.asObservable();

  initialize(goldenLayout: GoldenLayout, componentInitCallbackFactory: ComponentInitCallbackFactory) {
    super.initialize(goldenLayout, componentInitCallbackFactory);

    this.goldenLayout.on('componentCreated', (component) => {
      this.componentCreatedSubject.next(component);
    });

    this.goldenLayout.on('itemDestroyed', (item) => {
      if (item.type === 'component') {
        this.componentDestroyedSubject.next(item);
      }
    });

    this.goldenLayout.on('initialised', () => {
      this.initializedSubject.next();
      this.initializedSubject.complete();
    });

    this.goldenLayout.on('activeContentItemChanged', (item) => {
      this.activeContentItemChangedSubject.next(item);
    });
  }

  destroy() {
    this.initializedSubject.complete();
    this.initializedSubject = new AsyncSubject<void>();
    this.initialized$ = this.initializedSubject.asObservable();
    this.goldenLayout.destroy();
  }
}
